var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoundOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5678 7.75937C18.278 7.46953 17.8431 7.46953 17.5533 7.75937C17.2635 8.04921 17.2635 8.4841 17.5533 8.77389C18.8579 10.0785 18.8579 12.1078 17.5533 13.4122C17.2635 13.702 17.2635 14.1369 17.5533 14.4267C17.6983 14.5717 17.8431 14.7165 18.1332 14.7165C18.2783 14.7165 18.5681 14.7165 18.7132 14.4267C20.4522 12.8325 20.4522 9.78864 18.5679 7.75908L18.5678 7.75937Z",
    fill: "#969FA8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6387 0.802087C13.6387 0.802087 6.10148 7.32508 5.37658 7.32508H2.04288C1.31798 7.32508 0.738281 7.90477 0.738281 8.62967V13.1229C0.738281 13.8477 1.3182 14.5723 2.18769 14.5723H4.94169C5.81141 14.5723 13.6388 21.3852 13.6388 21.3852C14.0737 21.82 15.2333 21.9651 15.2333 20.5155V1.38212C15.2333 0.0775258 14.3637 0.0775259 13.6388 0.802201L13.6387 0.802087Z",
    fill: "#969FA8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73828 20.3154L19.4766 2.31538",
    stroke: "#969FA8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff);
export default __webpack_public_path__ + "static/media/soundOff.86a031226df46be4ecfdd806e9523fa7.svg";
export { ForwardRef as ReactComponent };